import React from "react";

export interface ConnectMarketContext {
    w: any
}

export const connectMarketContext = React.createContext<ConnectMarketContext>({
    w: window,
});
